/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2022/8/12 14:41
 * @des  document相关方法封装(解决ios等不支持focusout问题)
 */
import {remove} from './arrayutil'

/************************document点击监听start************************************/
let docClickListeners = []
let onDocClickCallback = null

/**
 * 监听文档点击
 * @param listener
 */
export function addDocClickListener (listener) {
  if (listener) {
    docClickListeners.push(listener)
    initOnDocClickListenersCallbackIfNeed()
  }
}

/**
 * 移除文档点击监听
 * @param listener
 */
export function removeDocClickListener (listener) {
  if (listener) {
    remove(docClickListeners, listener)
  }
}

/**
 * 初始化文档点击监听
 */
function initOnDocClickListenersCallbackIfNeed () {
  if (onDocClickCallback === null) {
    onDocClickCallback = function (event) {
      for (let i = 0; i < docClickListeners.length; ++i) {
        let listener = docClickListeners[i]
        if (listener) {
          listener(event)
        }
      }
    }
    document.addEventListener('click', onDocClickCallback)
  }
}

/************************document点击监听end************************************/



// WEBPACK FOOTER //
// ./src/base/util/document.js